import _get from 'lodash/get';

const renderHocPage = (props, queryName = 'pageQuery') => (
  !_get(props, [queryName, 'loading']) && !_get(props, [queryName, 'error'])
);

export default renderHocPage;
